import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography, QRCode, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import "../styles/ConfigSuccessPage.css";

// Импортируем нужные картинки (логотипы кнопок). 
// Пусть они у вас лежат, например, в папке /assets 
import appStoreBadge from "../appstore.png";
import googlePlayBadge from "../googleplay.png";
import microsoftBadge from "../microsoft.png";

const { Title, Paragraph } = Typography;

const ConfigSuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Извлекаем config
  const { config } = location.state || {};

  // Если пользователь открывает страницу напрямую, а state пуст — редирект
  useEffect(() => {
    if (!config) {
      navigate("/");
    }
  }, [config, navigate]);

  const [messageApi, contextHolder] = message.useMessage();

  const handleCopy = async () => {
    if (!config) {
      messageApi.error("Конфигурация недоступна для копирования.");
      return;
    }

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(config);
      } else {
        // Фолбэк для http или старых браузеров
        const textArea = document.createElement("textarea");
        textArea.value = config;
        textArea.style.position = "fixed";
        textArea.style.left = "-99999px";
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }
      messageApi.success("Скопировано в буфер обмена!");
    } catch {
      messageApi.error("Не удалось скопировать конфигурацию.");
    }
  };

  if (!config) return null;

  return (
    <div className="config-success-container">
      {contextHolder}
      <Title className="greeting">
        Подписка оформлена <span className="celebrate-emoji">🎉</span>
      </Title>
      <div className="gray-container-cfg">
        <div className="white-container-cfg">
          <div className="config-block">
            <Paragraph className="config-text">{config}</Paragraph>
            <CopyOutlined className="copy-icon" onClick={handleCopy} />
          </div>
        </div>
      </div>

      <div className="qrcode-container">
        <QRCode value={config} />
      </div>

      <div>
        <div className="store-buttons">
          <a
            href="https://apps.apple.com/us/app/hiddify-proxy-vpn/id6596777532?platform=iphone"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={appStoreBadge} alt="App Store" className="store-badge" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=app.hiddify.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={googlePlayBadge}
              alt="Google Play"
              className="store-badge"
            />
          </a>
          <a
            href="https://apps.microsoft.com/detail/Hiddify/9pdfnl3qv2s5?mode=mini"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={microsoftBadge}
              alt="Microsoft Store"
              className="store-badge"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ConfigSuccessPage;
